import { LitElement as at, css as ht, html as pt } from "lit";
import { state as dt, property as L } from "lit/decorators.js";
import { unsafeSVG as mt } from "lit/directives/unsafe-svg.js";
const vt = (o, t, i) => {
  const e = o[t];
  return e ? typeof e == "function" ? e() : Promise.resolve(e) : new Promise((s, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== i ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, gt = ":host{display:inline-flex;width:var(--icon-size);min-width:var(--icon-size);height:var(--icon-size);min-height:var(--icon-size)}:host>svg{width:100%;height:100%}:host([size=xxs]){--icon-size: 16px}:host([size=xs]){--icon-size: 20px}:host([size=sm]){--icon-size: 24px}:host([size=md]){--icon-size: 32px}";
var ut = Object.defineProperty, N = (o, t, i, e) => {
  for (var s = void 0, n = o.length - 1, r; n >= 0; n--)
    (r = o[n]) && (s = r(t, i, s) || s);
  return s && ut(t, i, s), s;
};
const ft = "muse-icon", q = class q extends at {
  constructor() {
    super(...arguments), this._currentSvg = "", this.ariaHidden = "true";
  }
  //#region -- Base
  /**
   * @ignore
   */
  static get styles() {
    return ht([gt]);
  }
  //#endregion
  //#region -- DOM References
  //#endregion
  //#region -- Computed
  //#endregion
  //#region -- Lifecycles
  /**
   * @ignore
   */
  async attributeChangedCallback(t, i, e) {
    if (super.attributeChangedCallback(t, i, e), t === "name" && typeof e == "string") {
      const { default: s } = await vt(/* @__PURE__ */ Object.assign({ "../icons/24/accessibility-easy-language.svg": () => import("../icons/24/accessibility-easy-language.svg?raw"), "../icons/24/accessibility-physical-impairment.svg": () => import("../icons/24/accessibility-physical-impairment.svg?raw"), "../icons/24/accessibility-sign-language.svg": () => import("../icons/24/accessibility-sign-language.svg?raw"), "../icons/24/alert-circle.svg": () => import("./alert-circle-C0d1ni7h.js"), "../icons/24/alert-triangle.svg": () => import("./alert-triangle-BPZ2q4M0.js"), "../icons/24/archive.svg": () => import("./archive-BfWzVuv2.js"), "../icons/24/arrow-left.svg": () => import("./arrow-left-CAmGhEVP.js"), "../icons/24/arrow-right.svg": () => import("./arrow-right-Bjq1Eqhl.js"), "../icons/24/bag.svg": () => import("./bag-BdwkYOG2.js"), "../icons/24/bell-filled.svg": () => import("./bell-filled-VZ1r8IZn.js"), "../icons/24/bell.svg": () => import("./bell-S3EOoWX0.js"), "../icons/24/boat.svg": () => import("./boat-Bu7igsMN.js"), "../icons/24/bookmark-filled.svg": () => import("./bookmark-filled-D6kcfZMz.js"), "../icons/24/bookmark.svg": () => import("./bookmark-CZ6TIv2F.js"), "../icons/24/box-send.svg": () => import("./box-send-CJrzsQjc.js"), "../icons/24/building-arch.svg": () => import("./building-arch-CSxEu3pN.js"), "../icons/24/building-community.svg": () => import("./building-community-Bs6zmxaz.js"), "../icons/24/building-factory.svg": () => import("./building-factory-Cw_3GiA2.js"), "../icons/24/building-government.svg": () => import("./building-government-Br8ZLlDm.js"), "../icons/24/building-monument.svg": () => import("./building-monument-CSUg_xRl.js"), "../icons/24/building-skyscraper.svg": () => import("./building-skyscraper-BSWZAfZY.js"), "../icons/24/building.svg": () => import("./building-DGDfuGNg.js"), "../icons/24/calendar-plus.svg": () => import("./calendar-plus-3uTxsFiP.js"), "../icons/24/calendar.svg": () => import("./calendar-BOIURIf0.js"), "../icons/24/car.svg": () => import("./car-B9dW3bZH.js"), "../icons/24/cart.svg": () => import("./cart-Cro-pacG.js"), "../icons/24/cash.svg": () => import("./cash-B9q-A3aa.js"), "../icons/24/check-circle.svg": () => import("./check-circle-gPmT6d2b.js"), "../icons/24/check-interactive.svg": () => import("./check-interactive-DDePYDGy.js"), "../icons/24/check.svg": () => import("./check-DL7d6m43.js"), "../icons/24/chevron-double-left.svg": () => import("./chevron-double-left-Dh_7zYlC.js"), "../icons/24/chevron-double-right.svg": () => import("./chevron-double-right-DoQCfbd7.js"), "../icons/24/chevron-down.svg": () => import("./chevron-down-cquZ3mTp.js"), "../icons/24/chevron-left.svg": () => import("./chevron-left-C87RKiNp.js"), "../icons/24/chevron-right.svg": () => import("./chevron-right-LxOVM3L-.js"), "../icons/24/chevron-up.svg": () => import("./chevron-up-B6N5Jb8n.js"), "../icons/24/clipboard-money.svg": () => import("./clipboard-money-EyMLkM37.js"), "../icons/24/clock.svg": () => import("./clock-CVgc_5X4.js"), "../icons/24/close-interactive.svg": () => import("./close-interactive-DX47WVi1.js"), "../icons/24/close.svg": () => import("./close-B9hx5B05.js"), "../icons/24/cloud-off.svg": () => import("./cloud-off-Cl4DGrrw.js"), "../icons/24/cloud.svg": () => import("./cloud-CKptwdYj.js"), "../icons/24/coins.svg": () => import("./coins-DRPFIRRw.js"), "../icons/24/communication.svg": () => import("./communication-C4dXAyHy.js"), "../icons/24/contacts.svg": () => import("./contacts-BV2q61nN.js"), "../icons/24/copy.svg": () => import("./copy-D-Q6bL9m.js"), "../icons/24/copyright.svg": () => import("./copyright-DNmCXcQu.js"), "../icons/24/couch.svg": () => import("./couch-CHSgDImo.js"), "../icons/24/crown.svg": () => import("./crown-DY7525o4.js"), "../icons/24/dots-horizontal.svg": () => import("./dots-horizontal-DTkYMAgk.js"), "../icons/24/dots-vertical.svg": () => import("./dots-vertical-pmu5wuhi.js"), "../icons/24/download.svg": () => import("./download-Cahbr_eJ.js"), "../icons/24/edit-off.svg": () => import("./edit-off-N6OBFSWH.js"), "../icons/24/edit.svg": () => import("./edit-CYSKUqzZ.js"), "../icons/24/education.svg": () => import("./education-D98Qe7Fu.js"), "../icons/24/euro.svg": () => import("./euro-DgsXIUI4.js"), "../icons/24/eye-closed.svg": () => import("./eye-closed-Cr8YjaXF.js"), "../icons/24/eye-crossed-out.svg": () => import("./eye-crossed-out-D2c-_m1K.js"), "../icons/24/eye.svg": () => import("./eye-ynsDuih1.js"), "../icons/24/file-certified.svg": () => import("./file-certified-4YGREECF.js"), "../icons/24/file-chart.svg": () => import("./file-chart-CnbaLLVu.js"), "../icons/24/file-download.svg": () => import("./file-download-B0MY5Xy2.js"), "../icons/24/file-error.svg": () => import("./file-error-CzJWA4Hl.js"), "../icons/24/file-image.svg": () => import("./file-image-Bz_dct-o.js"), "../icons/24/file-invoice.svg": () => import("./file-invoice-B0ohT4Or.js"), "../icons/24/file-more.svg": () => import("./file-more-BVLCuOo0.js"), "../icons/24/file-music.svg": () => import("./file-music-DtprsnGt.js"), "../icons/24/file-stats.svg": () => import("./file-stats-BFb0fMtG.js"), "../icons/24/file-text.svg": () => import("./file-text-DpySciHM.js"), "../icons/24/file-upload.svg": () => import("./file-upload-CtEUZLuA.js"), "../icons/24/file-video.svg": () => import("./file-video-CVwMjecA.js"), "../icons/24/file.svg": () => import("./file-HzpDNqgO.js"), "../icons/24/filter-filled.svg": () => import("./filter-filled-DuGGjFYW.js"), "../icons/24/filter-plus.svg": () => import("./filter-plus-D4Ga_kbV.js"), "../icons/24/filter-reset.svg": () => import("./filter-reset-DgLt9aJV.js"), "../icons/24/filter.svg": () => import("./filter-Fm7KxIym.js"), "../icons/24/forms.svg": () => import("./forms-CsocadBO.js"), "../icons/24/globe-dollar.svg": () => import("./globe-dollar-DNNWQPwS.js"), "../icons/24/globe.svg": () => import("./globe-DvPAptZI.js"), "../icons/24/grave.svg": () => import("./grave-253eWmkh.js"), "../icons/24/grip-horizontal.svg": () => import("./grip-horizontal-CXEVvdx2.js"), "../icons/24/hamburger.svg": () => import("./hamburger-DOp0Ke21.js"), "../icons/24/health.svg": () => import("./health-BUgb9ed_.js"), "../icons/24/home.svg": () => import("./home-BM79_w5k.js"), "../icons/24/hourglass.svg": () => import("./hourglass-CPmxUQJs.js"), "../icons/24/id-card.svg": () => import("./id-card-DHVvIzrU.js"), "../icons/24/info-circle.svg": () => import("./info-circle-BESfnmw2.js"), "../icons/24/info-interactive-filled.svg": () => import("./info-interactive-filled-ZuWt20ja.js"), "../icons/24/info-interactive.svg": () => import("./info-interactive-V53l4juR.js"), "../icons/24/key-crossed-out.svg": () => import("./key-crossed-out-DKzeasxR.js"), "../icons/24/key.svg": () => import("./key-CSxOgQd5.js"), "../icons/24/layout-grid.svg": () => import("./layout-grid-CWw_JBeJ.js"), "../icons/24/layout-list.svg": () => import("./layout-list-BDSxwzrm.js"), "../icons/24/layout-three-columns.svg": () => import("./layout-three-columns-CkVcmZix.js"), "../icons/24/layout-two-columns.svg": () => import("./layout-two-columns-CjXLQaWt.js"), "../icons/24/lifebuoy.svg": () => import("./lifebuoy-Czmjbtt-.js"), "../icons/24/link-crossed-out.svg": () => import("./link-crossed-out-Dq74pnyl.js"), "../icons/24/link-external.svg": () => import("./link-external-CIQNeux2.js"), "../icons/24/link.svg": () => import("./link-DpUkZ2BB.js"), "../icons/24/load-more.svg": () => import("./load-more-B-Tisfef.js"), "../icons/24/loader-quarter.svg": () => import("./loader-quarter-BYhEYxbo.js"), "../icons/24/loader.svg": () => import("./loader-sknqdCHk.js"), "../icons/24/location-1-filled.svg": () => import("./location-1-filled-DigCHPCt.js"), "../icons/24/location-1.svg": () => import("./location-1-Bpt5t98v.js"), "../icons/24/location-2.svg": () => import("./location-2-KtkZ_HBP.js"), "../icons/24/lock-closed.svg": () => import("./lock-closed-Bv-fWATH.js"), "../icons/24/lock-open.svg": () => import("./lock-open-Y6QIO85Q.js"), "../icons/24/logout.svg": () => import("./logout-BI7YAFRY.js"), "../icons/24/loudspeaker.svg": () => import("./loudspeaker-BQ1BKjb2.js"), "../icons/24/mail-check.svg": () => import("./mail-check-BST4YLPp.js"), "../icons/24/mail-forward.svg": () => import("./mail-forward-CySheXI5.js"), "../icons/24/mail-open.svg": () => import("./mail-open-CP8Uyuh7.js"), "../icons/24/mail-x.svg": () => import("./mail-x-mXMCbp3D.js"), "../icons/24/mail.svg": () => import("./mail-D6jgnCFG.js"), "../icons/24/map-location.svg": () => import("./map-location-BbB-5O4k.js"), "../icons/24/map.svg": () => import("./map-BSqO5yTN.js"), "../icons/24/message.svg": () => import("./message-Dc_fCKlS.js"), "../icons/24/microscope.svg": () => import("./microscope-DVNKbLpg.js"), "../icons/24/minus-interactive.svg": () => import("./minus-interactive-DdAmp68h.js"), "../icons/24/minus.svg": () => import("./minus-Blkirrxz.js"), "../icons/24/pause-interactive.svg": () => import("./pause-interactive-B9KN3TMQ.js"), "../icons/24/phone.svg": () => import("./phone-DXUp5mFa.js"), "../icons/24/play-interactive.svg": () => import("./play-interactive-C-qG0pHo.js"), "../icons/24/plus-interactive.svg": () => import("./plus-interactive-Uxlo-Vck.js"), "../icons/24/plus.svg": () => import("./plus-B4tK6iHC.js"), "../icons/24/printer.svg": () => import("./printer-C83yI47a.js"), "../icons/24/question-circle.svg": () => import("./question-circle-B6wQJtzI.js"), "../icons/24/question-interactive-filled.svg": () => import("./question-interactive-filled-BYWZZlW7.js"), "../icons/24/question-interactive.svg": () => import("./question-interactive-ke_zjxi-.js"), "../icons/24/receipt.svg": () => import("./receipt-BqLskD_A.js"), "../icons/24/refresh.svg": () => import("./refresh-B_LF1Km5.js"), "../icons/24/register.svg": () => import("./register-CXzCkN5e.js"), "../icons/24/reload.svg": () => import("./reload-3cKK0hrq.js"), "../icons/24/rocket.svg": () => import("./rocket-DsLduvae.js"), "../icons/24/save.svg": () => import("./save-BN8a3Xaj.js"), "../icons/24/scroll.svg": () => import("./scroll-DaTuFXb9.js"), "../icons/24/search-check.svg": () => import("./search-check-096gmVwQ.js"), "../icons/24/search-x.svg": () => import("./search-x-D_xLN2Cz.js"), "../icons/24/search.svg": () => import("./search-BSt3J6uW.js"), "../icons/24/settings-filled.svg": () => import("./settings-filled-D89U3rq-.js"), "../icons/24/settings.svg": () => import("./settings-Us7IA-Rw.js"), "../icons/24/share-1.svg": () => import("./share-1-ZdulFFLd.js"), "../icons/24/share-2.svg": () => import("./share-2-8zkrk380.js"), "../icons/24/shield-filled.svg": () => import("./shield-filled-mJxsH0qA.js"), "../icons/24/shield-half.svg": () => import("./shield-half-CrYovoZE.js"), "../icons/24/shield-question.svg": () => import("./shield-question-B_Efb79N.js"), "../icons/24/shield-third.svg": () => import("./shield-third-Uy9VL2sc.js"), "../icons/24/shield.svg": () => import("./shield-CzF7xaXc.js"), "../icons/24/sort-alphabet-down.svg": () => import("./sort-alphabet-down-DJq0Kqa7.js"), "../icons/24/sort-alphabet-up.svg": () => import("./sort-alphabet-up-r_Qd2rdj.js"), "../icons/24/sort-down.svg": () => import("./sort-down-DlwV7qZX.js"), "../icons/24/sort-numbers-down.svg": () => import("./sort-numbers-down-BIAOBSCo.js"), "../icons/24/sort-numbers-up.svg": () => import("./sort-numbers-up-CfQCFkCS.js"), "../icons/24/sort-up.svg": () => import("./sort-up-NBSgCWBH.js"), "../icons/24/sort.svg": () => import("./sort-DlmBO6RL.js"), "../icons/24/stack.svg": () => import("./stack-DoaKm9AO.js"), "../icons/24/star-filled.svg": () => import("./star-filled-_7GVBTU5.js"), "../icons/24/star.svg": () => import("./star-v23eKwhz.js"), "../icons/24/statistic.svg": () => import("./statistic-CpQKR-XN.js"), "../icons/24/stop.svg": () => import("./stop-BrxQ8BEd.js"), "../icons/24/stroller.svg": () => import("./stroller-G-xtclvK.js"), "../icons/24/support.svg": () => import("./support-CbgJe6lC.js"), "../icons/24/thumbs-down.svg": () => import("./thumbs-down-BMscpXhX.js"), "../icons/24/thumbs-up.svg": () => import("./thumbs-up-Bp2M9n47.js"), "../icons/24/trash.svg": () => import("./trash-Cbq2b4Xx.js"), "../icons/24/tree.svg": () => import("./tree-ZGLB04Io.js"), "../icons/24/trolley.svg": () => import("./trolley-BbgM0vyY.js"), "../icons/24/undo.svg": () => import("./undo-DGA0ebnQ.js"), "../icons/24/upload.svg": () => import("./upload-Kaktx3p8.js"), "../icons/24/user-check.svg": () => import("./user-check-DMq5y8yQ.js"), "../icons/24/user-circle.svg": () => import("./user-circle-C66J9jHS.js"), "../icons/24/user-group.svg": () => import("./user-group-BPhJlKoY.js"), "../icons/24/user-x.svg": () => import("./user-x-BGA7eEmK.js"), "../icons/24/user.svg": () => import("./user-rKfbEjDM.js"), "../icons/24/users.svg": () => import("./users-CtmETrkx.js") }), `../icons/24/${this.name}.svg`, 4);
      this._currentSvg = s;
    }
  }
  //#endregion
  //#region -- Methods
  //#endregion
  //#region -- Events
  //#endregion
  //#region -- Render
  /**
   * @ignore
   */
  render() {
    return this.name ? mt(this._currentSvg) : pt`
          <slot></slot>
        `;
  }
  //#endregion
};
q.shadowRootOptions = {
  mode: "open",
  delegatesFocus: !0
};
let $ = q;
N([
  dt()
], $.prototype, "_currentSvg");
N([
  L({ reflect: !0 })
], $.prototype, "name");
N([
  L({ reflect: !0 })
], $.prototype, "size");
N([
  L({ attribute: "aria-hidden", reflect: !0 })
], $.prototype, "ariaHidden");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const O = globalThis, B = O.ShadowRoot && (O.ShadyCSS === void 0 || O.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, st = Symbol(), D = /* @__PURE__ */ new WeakMap();
let $t = class {
  constructor(o, t, i) {
    if (this._$cssResult$ = !0, i !== st) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = o, this.t = t;
  }
  get styleSheet() {
    let o = this.o;
    const t = this.t;
    if (B && o === void 0) {
      const i = t !== void 0 && t.length === 1;
      i && (o = D.get(t)), o === void 0 && ((this.o = o = new CSSStyleSheet()).replaceSync(this.cssText), i && D.set(t, o));
    }
    return o;
  }
  toString() {
    return this.cssText;
  }
};
const _t = (o) => new $t(typeof o == "string" ? o : o + "", void 0, st), yt = (o, t) => {
  if (B) o.adoptedStyleSheets = t.map((i) => i instanceof CSSStyleSheet ? i : i.styleSheet);
  else for (const i of t) {
    const e = document.createElement("style"), s = O.litNonce;
    s !== void 0 && e.setAttribute("nonce", s), e.textContent = i.cssText, o.appendChild(e);
  }
}, V = B ? (o) => o : (o) => o instanceof CSSStyleSheet ? ((t) => {
  let i = "";
  for (const e of t.cssRules) i += e.cssText;
  return _t(i);
})(o) : o;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: At, defineProperty: bt, getOwnPropertyDescriptor: Et, getOwnPropertyNames: St, getOwnPropertySymbols: wt, getPrototypeOf: xt } = Object, A = globalThis, W = A.trustedTypes, Pt = W ? W.emptyScript : "", K = A.reactiveElementPolyfillSupport, w = (o, t) => o, j = { toAttribute(o, t) {
  switch (t) {
    case Boolean:
      o = o ? Pt : null;
      break;
    case Object:
    case Array:
      o = o == null ? o : JSON.stringify(o);
  }
  return o;
}, fromAttribute(o, t) {
  let i = o;
  switch (t) {
    case Boolean:
      i = o !== null;
      break;
    case Number:
      i = o === null ? null : Number(o);
      break;
    case Object:
    case Array:
      try {
        i = JSON.parse(o);
      } catch {
        i = null;
      }
  }
  return i;
} }, ot = (o, t) => !At(o, t), F = { attribute: !0, type: String, converter: j, reflect: !1, hasChanged: ot };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), A.litPropertyMetadata ?? (A.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class y extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, i = F) {
    if (i.state && (i.attribute = !1), this._$Ei(), this.elementProperties.set(t, i), !i.noAccessor) {
      const e = Symbol(), s = this.getPropertyDescriptor(t, e, i);
      s !== void 0 && bt(this.prototype, t, s);
    }
  }
  static getPropertyDescriptor(t, i, e) {
    const { get: s, set: n } = Et(this.prototype, t) ?? { get() {
      return this[i];
    }, set(r) {
      this[i] = r;
    } };
    return { get() {
      return s == null ? void 0 : s.call(this);
    }, set(r) {
      const a = s == null ? void 0 : s.call(this);
      n.call(this, r), this.requestUpdate(t, a, e);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? F;
  }
  static _$Ei() {
    if (this.hasOwnProperty(w("elementProperties"))) return;
    const t = xt(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(w("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(w("properties"))) {
      const i = this.properties, e = [...St(i), ...wt(i)];
      for (const s of e) this.createProperty(s, i[s]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const i = litPropertyMetadata.get(t);
      if (i !== void 0) for (const [e, s] of i) this.elementProperties.set(e, s);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [i, e] of this.elementProperties) {
      const s = this._$Eu(i, e);
      s !== void 0 && this._$Eh.set(s, i);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const i = [];
    if (Array.isArray(t)) {
      const e = new Set(t.flat(1 / 0).reverse());
      for (const s of e) i.unshift(V(s));
    } else t !== void 0 && i.push(V(t));
    return i;
  }
  static _$Eu(t, i) {
    const e = i.attribute;
    return e === !1 ? void 0 : typeof e == "string" ? e : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((i) => this.enableUpdating = i), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((i) => i(this));
  }
  addController(t) {
    var i;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((i = t.hostConnected) == null || i.call(t));
  }
  removeController(t) {
    var i;
    (i = this._$EO) == null || i.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), i = this.constructor.elementProperties;
    for (const e of i.keys()) this.hasOwnProperty(e) && (t.set(e, this[e]), delete this[e]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return yt(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((i) => {
      var e;
      return (e = i.hostConnected) == null ? void 0 : e.call(i);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((i) => {
      var e;
      return (e = i.hostDisconnected) == null ? void 0 : e.call(i);
    });
  }
  attributeChangedCallback(t, i, e) {
    this._$AK(t, e);
  }
  _$EC(t, i) {
    var e;
    const s = this.constructor.elementProperties.get(t), n = this.constructor._$Eu(t, s);
    if (n !== void 0 && s.reflect === !0) {
      const r = (((e = s.converter) == null ? void 0 : e.toAttribute) !== void 0 ? s.converter : j).toAttribute(i, s.type);
      this._$Em = t, r == null ? this.removeAttribute(n) : this.setAttribute(n, r), this._$Em = null;
    }
  }
  _$AK(t, i) {
    var e;
    const s = this.constructor, n = s._$Eh.get(t);
    if (n !== void 0 && this._$Em !== n) {
      const r = s.getPropertyOptions(n), a = typeof r.converter == "function" ? { fromAttribute: r.converter } : ((e = r.converter) == null ? void 0 : e.fromAttribute) !== void 0 ? r.converter : j;
      this._$Em = n, this[n] = a.fromAttribute(i, r.type), this._$Em = null;
    }
  }
  requestUpdate(t, i, e) {
    if (t !== void 0) {
      if (e ?? (e = this.constructor.getPropertyOptions(t)), !(e.hasChanged ?? ot)(this[t], i)) return;
      this.P(t, i, e);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, i, e) {
    this._$AL.has(t) || this._$AL.set(t, i), e.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (i) {
      Promise.reject(i);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [n, r] of this._$Ep) this[n] = r;
        this._$Ep = void 0;
      }
      const s = this.constructor.elementProperties;
      if (s.size > 0) for (const [n, r] of s) r.wrapped !== !0 || this._$AL.has(n) || this[n] === void 0 || this.P(n, this[n], r);
    }
    let i = !1;
    const e = this._$AL;
    try {
      i = this.shouldUpdate(e), i ? (this.willUpdate(e), (t = this._$EO) == null || t.forEach((s) => {
        var n;
        return (n = s.hostUpdate) == null ? void 0 : n.call(s);
      }), this.update(e)) : this._$EU();
    } catch (s) {
      throw i = !1, this._$EU(), s;
    }
    i && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var i;
    (i = this._$EO) == null || i.forEach((e) => {
      var s;
      return (s = e.hostUpdated) == null ? void 0 : s.call(e);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((i) => this._$EC(i, this[i]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
y.elementStyles = [], y.shadowRootOptions = { mode: "open" }, y[w("elementProperties")] = /* @__PURE__ */ new Map(), y[w("finalized")] = /* @__PURE__ */ new Map(), K == null || K({ ReactiveElement: y }), (A.reactiveElementVersions ?? (A.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const T = globalThis, R = T.trustedTypes, G = R ? R.createPolicy("lit-html", { createHTML: (o) => o }) : void 0, rt = "$lit$", g = `lit$${Math.random().toFixed(9).slice(2)}$`, nt = "?" + g, Ct = `<${nt}>`, _ = document, x = () => _.createComment(""), P = (o) => o === null || typeof o != "object" && typeof o != "function", I = Array.isArray, Ut = (o) => I(o) || typeof (o == null ? void 0 : o[Symbol.iterator]) == "function", z = `[ 	
\f\r]`, S = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, J = /-->/g, Z = />/g, u = RegExp(`>|${z}(?:([^\\s"'>=/]+)(${z}*=${z}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Y = /'/g, Q = /"/g, ct = /^(?:script|style|textarea|title)$/i, b = Symbol.for("lit-noChange"), p = Symbol.for("lit-nothing"), X = /* @__PURE__ */ new WeakMap(), f = _.createTreeWalker(_, 129);
function lt(o, t) {
  if (!I(o) || !o.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return G !== void 0 ? G.createHTML(t) : t;
}
const kt = (o, t) => {
  const i = o.length - 1, e = [];
  let s, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", r = S;
  for (let a = 0; a < i; a++) {
    const c = o[a];
    let h, d, l = -1, m = 0;
    for (; m < c.length && (r.lastIndex = m, d = r.exec(c), d !== null); ) m = r.lastIndex, r === S ? d[1] === "!--" ? r = J : d[1] !== void 0 ? r = Z : d[2] !== void 0 ? (ct.test(d[2]) && (s = RegExp("</" + d[2], "g")), r = u) : d[3] !== void 0 && (r = u) : r === u ? d[0] === ">" ? (r = s ?? S, l = -1) : d[1] === void 0 ? l = -2 : (l = r.lastIndex - d[2].length, h = d[1], r = d[3] === void 0 ? u : d[3] === '"' ? Q : Y) : r === Q || r === Y ? r = u : r === J || r === Z ? r = S : (r = u, s = void 0);
    const v = r === u && o[a + 1].startsWith("/>") ? " " : "";
    n += r === S ? c + Ct : l >= 0 ? (e.push(h), c.slice(0, l) + rt + c.slice(l) + g + v) : c + g + (l === -2 ? a : v);
  }
  return [lt(o, n + (o[i] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), e];
};
class C {
  constructor({ strings: t, _$litType$: i }, e) {
    let s;
    this.parts = [];
    let n = 0, r = 0;
    const a = t.length - 1, c = this.parts, [h, d] = kt(t, i);
    if (this.el = C.createElement(h, e), f.currentNode = this.el.content, i === 2 || i === 3) {
      const l = this.el.content.firstChild;
      l.replaceWith(...l.childNodes);
    }
    for (; (s = f.nextNode()) !== null && c.length < a; ) {
      if (s.nodeType === 1) {
        if (s.hasAttributes()) for (const l of s.getAttributeNames()) if (l.endsWith(rt)) {
          const m = d[r++], v = s.getAttribute(l).split(g), k = /([.?@])?(.*)/.exec(m);
          c.push({ type: 1, index: n, name: k[2], strings: v, ctor: k[1] === "." ? Ht : k[1] === "?" ? Tt : k[1] === "@" ? Rt : M }), s.removeAttribute(l);
        } else l.startsWith(g) && (c.push({ type: 6, index: n }), s.removeAttribute(l));
        if (ct.test(s.tagName)) {
          const l = s.textContent.split(g), m = l.length - 1;
          if (m > 0) {
            s.textContent = R ? R.emptyScript : "";
            for (let v = 0; v < m; v++) s.append(l[v], x()), f.nextNode(), c.push({ type: 2, index: ++n });
            s.append(l[m], x());
          }
        }
      } else if (s.nodeType === 8) if (s.data === nt) c.push({ type: 2, index: n });
      else {
        let l = -1;
        for (; (l = s.data.indexOf(g, l + 1)) !== -1; ) c.push({ type: 7, index: n }), l += g.length - 1;
      }
      n++;
    }
  }
  static createElement(t, i) {
    const e = _.createElement("template");
    return e.innerHTML = t, e;
  }
}
function E(o, t, i = o, e) {
  var s, n;
  if (t === b) return t;
  let r = e !== void 0 ? (s = i.o) == null ? void 0 : s[e] : i.l;
  const a = P(t) ? void 0 : t._$litDirective$;
  return (r == null ? void 0 : r.constructor) !== a && ((n = r == null ? void 0 : r._$AO) == null || n.call(r, !1), a === void 0 ? r = void 0 : (r = new a(o), r._$AT(o, i, e)), e !== void 0 ? (i.o ?? (i.o = []))[e] = r : i.l = r), r !== void 0 && (t = E(o, r._$AS(o, t.values), r, e)), t;
}
class Ot {
  constructor(t, i) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: i }, parts: e } = this._$AD, s = ((t == null ? void 0 : t.creationScope) ?? _).importNode(i, !0);
    f.currentNode = s;
    let n = f.nextNode(), r = 0, a = 0, c = e[0];
    for (; c !== void 0; ) {
      if (r === c.index) {
        let h;
        c.type === 2 ? h = new U(n, n.nextSibling, this, t) : c.type === 1 ? h = new c.ctor(n, c.name, c.strings, this, t) : c.type === 6 && (h = new Nt(n, this, t)), this._$AV.push(h), c = e[++a];
      }
      r !== (c == null ? void 0 : c.index) && (n = f.nextNode(), r++);
    }
    return f.currentNode = _, s;
  }
  p(t) {
    let i = 0;
    for (const e of this._$AV) e !== void 0 && (e.strings !== void 0 ? (e._$AI(t, e, i), i += e.strings.length - 2) : e._$AI(t[i])), i++;
  }
}
class U {
  get _$AU() {
    var t;
    return ((t = this._$AM) == null ? void 0 : t._$AU) ?? this.v;
  }
  constructor(t, i, e, s) {
    this.type = 2, this._$AH = p, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = e, this.options = s, this.v = (s == null ? void 0 : s.isConnected) ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const i = this._$AM;
    return i !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = i.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, i = this) {
    t = E(this, t, i), P(t) ? t === p || t == null || t === "" ? (this._$AH !== p && this._$AR(), this._$AH = p) : t !== this._$AH && t !== b && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Ut(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== p && P(this._$AH) ? this._$AA.nextSibling.data = t : this.T(_.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var i;
    const { values: e, _$litType$: s } = t, n = typeof s == "number" ? this._$AC(t) : (s.el === void 0 && (s.el = C.createElement(lt(s.h, s.h[0]), this.options)), s);
    if (((i = this._$AH) == null ? void 0 : i._$AD) === n) this._$AH.p(e);
    else {
      const r = new Ot(n, this), a = r.u(this.options);
      r.p(e), this.T(a), this._$AH = r;
    }
  }
  _$AC(t) {
    let i = X.get(t.strings);
    return i === void 0 && X.set(t.strings, i = new C(t)), i;
  }
  k(t) {
    I(this._$AH) || (this._$AH = [], this._$AR());
    const i = this._$AH;
    let e, s = 0;
    for (const n of t) s === i.length ? i.push(e = new U(this.O(x()), this.O(x()), this, this.options)) : e = i[s], e._$AI(n), s++;
    s < i.length && (this._$AR(e && e._$AB.nextSibling, s), i.length = s);
  }
  _$AR(t = this._$AA.nextSibling, i) {
    var e;
    for ((e = this._$AP) == null ? void 0 : e.call(this, !1, !0, i); t && t !== this._$AB; ) {
      const s = t.nextSibling;
      t.remove(), t = s;
    }
  }
  setConnected(t) {
    var i;
    this._$AM === void 0 && (this.v = t, (i = this._$AP) == null || i.call(this, t));
  }
}
class M {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, i, e, s, n) {
    this.type = 1, this._$AH = p, this._$AN = void 0, this.element = t, this.name = i, this._$AM = s, this.options = n, e.length > 2 || e[0] !== "" || e[1] !== "" ? (this._$AH = Array(e.length - 1).fill(new String()), this.strings = e) : this._$AH = p;
  }
  _$AI(t, i = this, e, s) {
    const n = this.strings;
    let r = !1;
    if (n === void 0) t = E(this, t, i, 0), r = !P(t) || t !== this._$AH && t !== b, r && (this._$AH = t);
    else {
      const a = t;
      let c, h;
      for (t = n[0], c = 0; c < n.length - 1; c++) h = E(this, a[e + c], i, c), h === b && (h = this._$AH[c]), r || (r = !P(h) || h !== this._$AH[c]), h === p ? t = p : t !== p && (t += (h ?? "") + n[c + 1]), this._$AH[c] = h;
    }
    r && !s && this.j(t);
  }
  j(t) {
    t === p ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class Ht extends M {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === p ? void 0 : t;
  }
}
class Tt extends M {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== p);
  }
}
class Rt extends M {
  constructor(t, i, e, s, n) {
    super(t, i, e, s, n), this.type = 5;
  }
  _$AI(t, i = this) {
    if ((t = E(this, t, i, 0) ?? p) === b) return;
    const e = this._$AH, s = t === p && e !== p || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== p && (e === p || s);
    s && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var i;
    typeof this._$AH == "function" ? this._$AH.call(((i = this.options) == null ? void 0 : i.host) ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class Nt {
  constructor(t, i, e) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = e;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    E(this, t);
  }
}
const tt = T.litHtmlPolyfillSupport;
tt == null || tt(C, U), (T.litHtmlVersions ?? (T.litHtmlVersions = [])).push("3.2.0");
const Mt = (o, t, i) => {
  const e = (i == null ? void 0 : i.renderBefore) ?? t;
  let s = e._$litPart$;
  if (s === void 0) {
    const n = (i == null ? void 0 : i.renderBefore) ?? null;
    e._$litPart$ = s = new U(t.insertBefore(x(), n), n, void 0, i ?? {});
  }
  return s._$AI(o), s;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class H extends y {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var t;
    const i = super.createRenderRoot();
    return (t = this.renderOptions).renderBefore ?? (t.renderBefore = i.firstChild), i;
  }
  update(t) {
    const i = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = Mt(i, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this.o) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this.o) == null || t.setConnected(!1);
  }
  render() {
    return b;
  }
}
var it;
H._$litElement$ = !0, H.finalized = !0, (it = globalThis.litElementHydrateSupport) == null || it.call(globalThis, { LitElement: H });
const et = globalThis.litElementPolyfillSupport;
et == null || et({ LitElement: H });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
function zt(o, t, i) {
  const e = i ? `${t}-${i}` : t;
  customElements.get(e) ? console.warn(
    `WARN: You are importing '${e}' more than once, which is not supported. Please remove the duplicated import.`
  ) : customElements.define(e, o);
}
const It = (o) => zt($, ft, o);
export {
  $ as I,
  It as r
};
